import * as Menu from '@radix-ui/react-dropdown-menu'
import { LogOut } from 'lucide-react'
import { useSignOut } from '@/api/auth'
import { useMe } from '@/api/hooks'

/**
 * The signed-in account: an initial in the top bar that opens to the email and "Sign out".
 * Only for app accounts; Cloudflare Access and local dev have nothing to sign out of here.
 */
export function AccountMenu() {
  const { data: me } = useMe()
  const { signOut, pending } = useSignOut()
  if (me?.auth !== 'session') return null

  const email = me.email ?? ''
  const initial = (email.trim()[0] ?? '?').toUpperCase()

  return (
    <Menu.Root>
      <Menu.Trigger
        aria-label={email ? `Account, ${email}` : 'Account'}
        className="inline-flex size-9 items-center justify-center rounded-full border border-line-strong min-[900px]:size-8 bg-surface-2 text-small font-semibold text-ink-2 transition-colors duration-150 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent data-[state=open]:text-ink"
      >
        {initial}
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Content
          align="end"
          sideOffset={8}
          className="gd-pop z-50 w-64 rounded-lg border border-line bg-surface-pop p-1.5 shadow-pop"
        >
          {email && (
            <>
              <div className="px-2.5 pb-2 pt-1.5">
                <p className="text-caption text-ink-3">Signed in as</p>
                <p className="mt-0.5 truncate text-small font-medium text-ink">{email}</p>
              </div>
              <Menu.Separator className="mx-1 mb-1 h-px bg-line" />
            </>
          )}
          <Menu.Item
            disabled={pending}
            onSelect={() => void signOut()}
            className="flex cursor-default select-none items-center gap-2.5 rounded-sm px-2.5 py-2 text-small text-ink outline-none data-[disabled]:opacity-50 data-[highlighted]:bg-[color-mix(in_oklab,var(--ink)_8%,transparent)]"
          >
            <LogOut className="size-4 shrink-0 text-ink-2" aria-hidden="true" />
            Sign out
          </Menu.Item>
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  )
}
